import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { SIDEBAR_ACTIONS } from '../../../constants/actionsConstants';
import RightModalLayout from '../../layouts/Modal/RightModalLayout';
import YoutubeEmbedVideoMC from '../../components/YoutubeEmbedVideoMC';

const NewsModal = ({ news = {}, autoplay }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Dashboard');

  const toggleNewsModal = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  const onSubmit = () => {
    toggleNewsModal();
  };

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('whats_news.modal.title')}
        submitAction={onSubmit}
        submitLabel={t('whats_news.modal.understood')}

      >
        <div className="tw-flex tw-flex-col tw-gap-4">
          <span className="tw-font-semibold tw-text-sm tw-text-gray-950">{news.title}</span>
          {news.media_type === 'video' && (
            <YoutubeEmbedVideoMC
              url={news.media_url}
              autoplay={autoplay}
            />
          )}
          {news.media_type === 'image' && (
            <div className="tw-relative tw-cursor-pointer">
              <img
                src={news.image_url}
                className="tw-w-full"
              />
            </div>
          )}
          <div
            className="order-terms-and-conditions"
            dangerouslySetInnerHTML={{ __html: news.description }}
          />
        </div>
      </RightModalLayout>
    </div>
  );
};

export default NewsModal;
